import React from "react";
import {observer} from "mobx-react";
import {Order, OrderStatus} from "../../../../../../services/orders/models";
import {Paper, Typography} from "../../../../../../common/components/libs";
import moment from "moment";
import {PaymentProviderType} from "../../../../../../services/general/models";
import {useStores} from "../../../../../../hooks";
import {Link} from "@material-ui/core";
import {Trans, useTranslation} from "react-i18next";
import {useHistory} from "react-router";


const OrderCard = ({order}: { order: Order }) => {
    const {generalStore, constantsStore} = useStores();
    const currencyFormatter = constantsStore.getCurrencyFormatter(generalStore.currency.id);
    const {i18n, t} = useTranslation(["general", "orders"]);
    const locale = i18n.language;
    const history = useHistory();

    const navigateTo = (orderId: number) => {
        history.push(`/stats/orders/${orderId}`);
    };

    return (
        <Paper p={5} style={{maxWidth: 400, width: "100%"}}>
            <div onClick={() => navigateTo(order.id)}>
                <Typography variant={"h6"}>
                    {t("general:number")}
                </Typography>
                <Typography variant={"body1"} style={{marginTop: 5}}>
                    {order.id}
                </Typography>

                <Typography variant={"h6"} style={{marginTop: 20}}>
                    {t("general:date")}
                </Typography>
                <Typography variant={"body1"} style={{marginTop: 5}}>
                    {moment(order.createdAt).format("DD.MM.YYYY HH:mm")}
                </Typography>

                <Typography variant={"h6"} style={{marginTop: 20}}>
                    {t("orders:sum")}
                </Typography>
                <Typography variant={"body1"} style={{marginTop: 5}}>
                    {currencyFormatter.toShowFormatted(order.totalPrice.price)}
                </Typography>

                <Typography variant={"h6"} style={{marginTop: 20}}>
                    {t("orders:deliveryType")}
                </Typography>
                <Typography variant={"body1"} style={{marginTop: 5}}>
                    {t(`orders:deliveryTypes.${order.deliveryDetails.type}`)}
                </Typography>

                <Typography variant={"h6"} style={{marginTop: 20}}>
                    {t("orders:paymentType")}
                </Typography>
                <Typography variant={"body1"} style={{marginTop: 5}}>
                    {t(`orders:paymentProviderType.${order.paymentDetails.type}`)}
                </Typography>

                <Typography variant={"h6"} style={{marginTop: 20}}>
                    {t("orders:paymentState")}
                </Typography>
                {(!order.paymentDetails.isPaid && order.status !== OrderStatus.canceledWithRefund && order.paymentDetails.type === PaymentProviderType.cloudpayments) &&
                    <Typography align="left" style={{color: "#f57c00"}}>
                        {t("orders:notPaid")}
                    </Typography>
                }
                {(order.paymentDetails.isPaid && order.status !== OrderStatus.canceledWithRefund && order.paymentDetails.type === PaymentProviderType.cloudpayments) &&
                    <Typography align="left" style={{color: "#388e3c"}}>
                        {t("orders:paid")}
                    </Typography>
                }
                {(order.status !== OrderStatus.canceledWithRefund && order.paymentDetails.type === PaymentProviderType.companyInvoice || order.paymentDetails.type === PaymentProviderType.offline || order.paymentDetails.type === PaymentProviderType.toBankCard) &&
                    <Typography align="left">
                        -
                    </Typography>
                }
                {(order.status === OrderStatus.canceledWithRefund) &&
                    <Typography align="left" style={{color: "#dc004e"}}>
                        {t("orders:return")}
                    </Typography>
                }

                <Typography variant={"h6"} style={{marginTop: 20}}>
                    {t("orders:orderState")}
                </Typography>
                <Typography align="left">
                    {t(`orders:orderStatus.${order.status}`)}
                </Typography>
                <Typography variant={"h6"} style={{marginTop: 20}}>
                    {t("orders:orderCheck")}
                </Typography>
                <Typography align="left">
                    {order.paymentDetails.receiptLink ?
                        <Link href={order.paymentDetails.receiptLink} variant="body2">
                            {t("orders:check")}
                        </Link> :
                        <p>-</p>
                    }
                </Typography>
            </div>
        </Paper>
    );
};

export default observer(OrderCard);
